const server = process.env.SERVER || 'http://localhost:3000'
const adminapi = 'web/adminapi'
export const API = {
  login: `${server}/${adminapi}/login/`,
  teams: `${server}/${adminapi}/teams/`,
  transactions: `${server}/${adminapi}/transactions/`,
  bills: `${server}/${adminapi}/bills/`
}



// WEBPACK FOOTER //
// ./src/assets/config.js